module.exports = __webpack_public_path__ + "static/media/Aviso de privacidad MPV.5402b457.pdf";